/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { useLocation, useHistory } from 'react-router-dom'
import { Typography, Link, Box, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useTranslation } from 'react-i18next'
import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import * as gdeTransactionLite from '../../../services/firestore/gdeTransactionsLite'
import { getUser, getUserRole } from '../../../redux/global'
import { userRoleAdmin, userRoleSuperUser } from '../../../common/constants'
import ImageContainer from './MultiImageContainer'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { useMergeState } from 'irmlib/hooks'
import { MaterialReactTable } from 'material-react-table'
import ExportCsv from '../../Controls/ExportCsv'
import { MenuButton } from '../../../irmlib/src/components/Controls'
import { MoreVert } from 'irmlib/icons'
import { useTheme } from '../../../irmlib/src/styles'
import { ReprocessImage, RetakeImageBox, UpdateImageTemplate, UpdateImageTemplateAndRef, UpdateImgRefImage } from './MenuActivities'
import { Visibility } from '@material-ui/icons'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { errorToast, successToast } from '../../../common/functions'
import * as constants from '../../../irmlib/src/common/constants'



const initialState = {
  images: []
}

const BoxImageDetails = () => {
  const location = useLocation()
  const theme = useTheme()
  const history = useHistory()
  const requestId = location.pathname.split('/')[2]
  const boxId = location.pathname.split('/')[3]
  const activityId = location.pathname.split('/')[4]
  const { t } = useTranslation()
  const [wmsCode, setWmsCode] = useState('')
  const [assetType, setAssetType] = useState('')
  const [boxStatus, setBoxStatus] = useState('')
  const [enableOptions, setEnableOptions] = useState(false)
  const [imagesRawData, setImagesRawData] = useState([])
  const [selectedImage, setSelectedImage] = useState(null)
  const [selectedImageIndex, setSelectedImageIndex] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [openReprocessImage, setOpenReprocessImage] = useState(false)
  const [openTemplateModal, setOpenTemplateModal] = useState(false)
  const [retakeImage, setRetakeImage] = useState(false)
  const [openChangeRefImg, setOpenChangeRefImg] = useState(false)
  const [openChangeTempAndRefImg, setOpenChangeTempAndRefImg] = useState(false)
  const [selectedRowData, setSelectedRowData] = useState(null)
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [selectedImageIds, setSelectedImageIds] = useState([])
  const [isDeleting, setIsDeleting] = useState(false)
  const [deleteTable, setDeleteTable] = useState(null)
  const [, setState, getState] = useMergeState(initialState)
  
  useEffect(async () => {
    getRequestDetails()
    const subscribeImagesListener = await gdeTransactions.imagesListner(setImagesRawData, activityId)
    return () => subscribeImagesListener()
  }, [])

  useEffect(() => {
    getImages()
  }, [imagesRawData])

  const convertUTCDateToLocalDate = (date) => {
    const date2 = new Date(date)
    const dateString = date2.toLocaleDateString()
    const timeString = date2.toLocaleTimeString()
    const newDate = `${dateString}, ${timeString}`
    return newDate
  }

  const parseLocaleDateToYMD = (localeDateString) => {
    const date = new Date(localeDateString)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const menuItems = [
    { value: 'Retake Image', id: 'createJobs_edit', label: t('Search.RetakeImage'), style: { color: theme.palette.primary.main } },
    { value: 'Reprocess Image', label: t('Search.ReprocessImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template', label: t('Search.ChangeTemplate'), style: { color: theme.palette.primary.main } },
    { value: 'Change Reference Image', label: t('Search.ChangeRefImage'), style: { color: theme.palette.primary.main } },
    { value: 'Change Template And Reference Image', label: t('Search.ChangeTemplateAndRefImage'), style: { color: theme.palette.primary.main } },
  ]
  const menuItems2 = [
    { value: 'Retake Image', id: 'createJobs_edit', label: t('Search.RetakeImage'), style: { color: theme.palette.primary.main } },
  ]
  // Columns for Images
  const columnsImage = [
    {
      header: t('tableColumns.boxId'),
      accessorKey: 'boxId',
      enableFiltering: false, // Matches filter: false
    },
    {
      header: t('tableColumns.barcode'),
      accessorKey: 'barCode',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('tableColumns.status'),
      accessorKey: 'status',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      accessorKey: 'formatError',
      header: t('tableColumns.format'),
    },
    {
      header: t('tableColumns.idpStatus'),
      accessorKey: 'idpStatus',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('tableColumns.idpException'),
      accessorKey: 'exception',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('smartCatalog.imgException'),
      accessorKey: 'exceptionNote',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    { 
      header: t('tableColumns.isProcessed'), 
      accessorKey: 'isProcessed',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
    },
    {
      header: t('tableColumns.assetType'),
      accessorKey: 'assetType',
      enableFiltering: false,
    },
    {
      header: t('reports.employeeLevel.employee'),
      accessorKey: 'userName',
      enableFiltering: false,
    },
    {
      header: t('tableColumns.createdTime'),
      accessorKey: 'createdTS',
      enableFiltering: true,
      filterVariant: 'custom',
      customFilterLogic: (value, filter) => {
        if (filter && filter.length > 0) {
          const localeDatePart = value.split(' ')[0]
          const datePart = parseLocaleDateToYMD(localeDatePart)
          return datePart !== filter[0]
        }
        return false
      },
      customFilterDisplay: (filterList, onChange, index, column) => (
        <TextField
          label={t('dashBoard.selectDate')}
          type="date"
          value={filterList[index] || ''}
          onChange={(event) => {
            const value = event.target.value
            filterList[index] = value === '' ? [] : [value]
            onChange(filterList[index], index, column)
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      ),
    },

    {
      accessorKey: 'images',
      header: t('tableColumns.images'),
      Cell: ({ row }) => {
        const rowData = row?.original?.images // assuming `images` is an array in each row
        if (rowData && rowData?.length !== 0) {
          return (
            <Visibility
          style={{ cursor: 'pointer', fontSize: 32 }}
           onClick={() => {
             handleOpen(0)
             setSelectedImage(rowData)
           }}/>
          )
        } else {
          return null
        }
      }
    },
    { 
      header: t('smartCatalog.sequenceId'), 
      accessorKey: 'sequenceId',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
      sortingFn: (rowA, rowB) => {
        const valueA = rowA.original.sequenceId === '-' ? Infinity : rowA.original.sequenceId
        const valueB = rowB.original.sequenceId === '-' ? Infinity : rowB.original.sequenceId
        return valueA - valueB
      },
      muiTableBodyCellProps: {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
        },
      },
    },
    { 
      header: t('smartCatalog.range'), 
      accessorKey: 'range',
      enableFiltering: true,
      filterVariant: 'multi-select', // Matches filterType: 'multiselect'
      muiTableBodyCellProps: {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
        },
      },
    },
    {
      header: t('tableColumns.imgReference'), 
      accessorKey: 'imgReference',
      Cell: ({ row }) => {
        const refImage = row?.original?.currentImageURL
        return (
          <Visibility
          style={{ cursor: 'pointer', fontSize: 32 }}
           onClick={() => {
             handleOpen(0)
             setSelectedImage(refImage)
           }}/>
        )
      }
    },
    {
      header: t('tableColumns.templateFields'),
      accessorKey: 'templateFields',
      size: 700,
      muiTableBodyCellProps: {
        sx: {
          display: 'flex',
          minWidth: 2800,
        },
      },
      Cell: ({ row }) => {
        const rowData = row?.original?.templateFields
        return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '4px', whiteSpace: 'normal', wordBreak: 'break-word', width: '100%' }}>
          {rowData.map((field, index) => (
            <div
            key={index}
            style={{
              padding: '0px 20px 0px 0px',
              wordBreak: 'break-word',
              width: '100%',
              whiteSpace: 'pre-wrap'
            }}
          >
            {field}
          </div>
          ))}
        </div>
        )
      }
    },
    enableOptions && getUser().role === 'SUPER USER'
      ? {
          accessorKey: 'modify',
          header: t('tableColumns.action'),
          Cell: ({ row }) => {
            const rowData = getState()?.images[row?.index]
            if (!rowData) return null
            const statuses = rowData?.status
            const upload = t(`jobStatusObj.${'uploaded'}`)
            const isReprocess = rowData?.isReprocess ?? false
            let customMenuItems = []
            if (rowData && 
              (
                (rowData?.isProcessed === false && rowData?.isPublished === true) || 
                (['pending', 'In Progress'].includes(rowData?.boxStatus)) ||
                (isReprocess)
              )) {
              customMenuItems = menuItems2
            } else {
              customMenuItems = menuItems
            }
            if (!statuses?.includes(upload)) {
              return (
                <MenuButton
                  id={'allJobs_ellipsis'}
                  buttonIcon={<MoreVert />}
                  rowdata={rowData}
                  items={customMenuItems}
                  onSelect={(value) => { onSelect(value, rowData) }}
              />
              )
            } else {
              return null
            }
          }
        }
      : null
  ].filter(Boolean)

  if (wmsCode === 'SKP' || assetType.includes('Box')) {
    const indexOfwmsStatusColumn = columnsImage.findIndex(column => column.accessorKey === 'barCode')
    if (indexOfwmsStatusColumn !== -1) {
      columnsImage.splice(indexOfwmsStatusColumn, 1)
    }
  }

  const columnsWithWidths = columnsImage.map((col) => {
    const headerLength = col.header.length
    let minWidth = 0
    if (headerLength < 8) {
      minWidth = headerLength * 8
    } else {
      minWidth = headerLength * 15
    }

    return {
      ...col,
      minSize: minWidth,
      muiTableHeadCellProps: {
        sx: {
          whiteSpace: 'nowrap',
          wordWrap: 'break-word',
          minWidth: `${minWidth}px`,
          overflow: 'visible',
          color: '#58595B',
          fontWeight: 'bold',
        },
      },
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',

        }
      },
    }
  })

  const getRequestDetails = async() => {
    try {
      const request = await gdeTransactionLite.getRequestById(requestId)
      setWmsCode(request?.wmsCode)
      setAssetType(request?.assetType)
      const userRole = getUserRole()
      if (userRole === userRoleAdmin || userRole === userRoleSuperUser) {
        setEnableOptions(true)
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    }
  }

  const getImages = async () => {
    try {
      setIsLoading(true)
      const imagesFormattedData = []
      const promise = imagesRawData.map((data, index) => {
        const actId = data.activityId
        return gdeTransactions.getActivityByID(data.activityId).then((res) => {
          return {
            activityId: actId,
            status: res.status
          }
        })
      })
      const allData = await Promise.all(promise)
      const eachBoxStatus = {}
      setBoxStatus(allData[0]?.status || '')
      allData.forEach(e => {
        eachBoxStatus[e.activityId] = e.status
      })
      imagesRawData && imagesRawData.forEach((data) => {
        const timestamp = convertUTCDateToLocalDate(data?.createTS)
        const rangeFromTo = data?.rangeFrom !== undefined && data?.rangeTo !== undefined
          ? `${data?.rangeFrom} - ${data?.rangeTo}`
          : '-'
        const format = data?.formatError !== undefined ? data?.formatError : '-'
        let formatString
        if (format === '-') {
          formatString = '-'
        } else {
          formatString = format ? 'Yes' : 'No'
        }
        let templateFields
        const template = data?.template
        const refImg = data?.imgReference
        const refImage = []

        if (refImg) {
          refImage.push(refImg)
        }

        if (template) {
          const fields = template
          templateFields = Object.keys(template).map((key) => {
            const data = `${key} (${template[key].fieldId})`
            return data
          })
        }
        imagesFormattedData.push({
          activityId: data.activityId,
          imageId: data.id,
          boxId: data.skpBoxNbr,
          barCode: data?.barcode || '-',
          createdTS: timestamp,
          assetType: data.assetType,
          isProcessed: data.isProcessed.toString(),
          isPublished: data.isPublished.toString(),
          // customTemplateName: data.customTemplateName,
          // status: data.status,
          status: t(`jobStatusObj.${data?.status}`),
          image: '',
          images: data.imgDetails?.imgPath,
          userName: data?.username,
          sequenceId: data?.sequenceId || '-',
          range: rangeFromTo,
          formatError: formatString,
          idpStatus: data?.idp?.status,
          exception: data?.idp?.exception,
          exceptionNote: data?.exceptionNote,
          currentImageURL: refImage,
          customer: data?.custId,
          boxStatus: eachBoxStatus[data.activityId],
          isReprocess: data?.isReprocess,
          templateFields: templateFields
        })
      })
      setState({ images: imagesFormattedData })
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleGoBack = () => {
    history.goBack()
  }

  // Breadcrumbs
  const breadcrumbs = [
    <Link underline='hover' onClick={() => handleGoBack()} color='primary' style={{ cursor: 'pointer' }}>
      {t('demo.requestId')}
    </Link>,
    <Link underline='hover' onClick={() => handleGoBack()} color='primary' style={{ cursor: 'pointer' }}
    >
      {requestId}
    </Link>,
    <Link underline='none' color='inherit'
    >
      {t('tableColumns.boxId')}
    </Link>,
    <Typography sx={{ color: 'text.primary' }}>
      {boxId}
    </Typography>,
  ]

  const BreadCrumbsComponent = () => {
    return (
      <Breadcrumbs separator='›' aria-label='breadcrumb'>
        {breadcrumbs}
      </Breadcrumbs>
    )
  }

  const handleClose = () => {
    setSelectedImageIndex(null)
  }

  const handleOpen = (index) => {
    setSelectedImageIndex(index)
  }

  const MultiImageContainer = () => (
    <div>
      {selectedImageIndex !== null && (
        <ImageContainer
          images={selectedImage}
          selectedImageIndex={selectedImageIndex}
          handleClose={handleClose}
        />
      )}
    </div>
  )

  const handleRetakeImage = (rowData) => {
    setSelectedRowData(rowData)
    setRetakeImage(true)
  }

  const handleCloseRetakeImageModal = () => {
    setRetakeImage(false)
    setSelectedRowData(null)
  }

  const handleOpenMenuItems = (rowData) => {
    setSelectedRowData(rowData)
    setOpenReprocessImage(true)
  }

  const handleCloseMenuItems = () => {
    setOpenReprocessImage(false)
    setSelectedRowData(null)
  }

  const handleOpenTemplateModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenTemplateModal(true)
  }

  const handleCloseTemplateModal = () => {
    setOpenTemplateModal(false)
    setSelectedRowData(null)
  }
  const handleOpenRefImgModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenChangeRefImg(true)
  }
  const handleCloseRefImgModal = () => {
    setOpenChangeRefImg(false)
    setSelectedRowData(null)
  }
  const handleOpenRefImgAndTempModal = (rowData) => {
    setSelectedRowData(rowData)
    setOpenChangeTempAndRefImg(true)
  }
  const handleCloseRefImgandTempModal = () => {
    setOpenChangeTempAndRefImg(false)
    setSelectedRowData(null)
  }

  // Action column select options
  const onSelect = (value, rowData) => {
    if (value === 'Retake Image') {
      handleRetakeImage(rowData)
    }
    if (value === 'Reprocess Image') {
      handleOpenMenuItems(rowData)
    }
    if (value === 'Change Template') {
      handleOpenTemplateModal(rowData)
    }
    if (value === 'Change Reference Image') {
      handleOpenRefImgModal(rowData)
    }
    if (value === 'Change Template And Reference Image') {
      handleOpenRefImgAndTempModal(rowData)
    }
  }

  const canBulkDeleteImages = enableOptions && [constants.activityStatus.completed, constants.activityStatus.failed].includes(boxStatus?.toLowerCase?.())
   
  const handleOpenDeleteDialog = (table) => {
    const selectedRows = table.getSelectedRowModel().rows.map((row) => row.original)
    const imageIds = selectedRows
      .map((row) => row.imageId)
      .filter(Boolean)

    if (imageIds.length === 0) {
      errorToast({ message: t('dataEntry.confirmRecordDelete'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      return
    }
    setSelectedImageIds(imageIds)
    setDeleteTable(table)
    setDeleteDialogOpen(true)
  }

  const handleCloseDeleteDialog = (forceClose = false) => {
    if (isDeleting && !forceClose) {
      return
    }

    setDeleteDialogOpen(false)
    setSelectedImageIds([])
    setDeleteTable(null)
  }

  const handleBulkDeleteImages = async () => {
    try {
      setIsDeleting(true)
      await gdeTransactions.bulkDeleteImages(activityId, selectedImageIds)
      successToast({
        message: t('toast.imagesDeleteSuccess', { deletedImagesCount: selectedImageIds.length }),
        title: t('toast.success'),
        autoHideDuration: 3000,
        isBlocking: false,
      })
      deleteTable?.resetRowSelection()
      handleCloseDeleteDialog(true)
    } catch (error) {
      errorToast({
        message: t('toast.imagesDeleteError'),
        title: t('toast.error'),
        autoHideDuration: 3000,
        isBlocking: false,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <MainRouteSubRoutePage
      mainTitle={t('routeTitles.imageDetails')}
      subTitle={<><GoBackSubtitle id={'BoxImageDetails_goBack'} />
        <BreadCrumbsComponent /></>}
    >
      <Box boxShadow={2} borderRadius={4}>
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '22px' }}>
          <Typography variant="h6" gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
            {t('demo.viewImgDetails')}
          </Typography>
        </div>
        <MaterialReactTable
          columns={columnsWithWidths}
          data={getState()?.images}
          state={{ showSkeletons: isLoading }}
          enableColumnFilters={true}
          enableRowSelection
          enableExport={true}
          enableGlobalFilter
          enableColumnFilter
          enableColumnSorting
          enableRowVirtualization={true}
          enablePagination={true}
          enableGrouping={true}
          enableColumnResizing={true}
          initialState={{
            density: 'compact',
            sorting: [
              {
                id: 'boxId',
                desc: false,
              },
              {
                id: 'sequenceId',
                desc: false,
              }
            ],
            columnVisibility: { images: true, modify: true },
          }}
          renderTopToolbarCustomActions={({ table, data }) => {
            const isDisabled = !table.getIsSomeRowsSelected()
            const isNoData = getState()?.images?.length === 0
            const isNoPageData = getState()?.images?.length > 4
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <ExportCsv
                  columns={columnsImage}
                  isDisabled={isDisabled}
                  isNoData={isNoData}
                  isNoPageData={isNoPageData}
                  table={table}
                />
                {canBulkDeleteImages && (
                  <Button
                    variant="outlined"
                    color="error"
                    disabled={isDisabled || isDeleting}
                    startIcon={<DeleteOutlineIcon />}
                    onClick={() => handleOpenDeleteDialog(table)}
                    sx={{ fontWeight: 'bold', textTransform: 'none' }}
                  >
                    {t('Search.deleteTemplate')}
                  </Button>
                )}
              </Box>
            )
          }}
          tableFor={'Box_ImageDetails'}
        /></Box>
      <MultiImageContainer />
      <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>{t('templates.confirm')}</DialogTitle>
        <DialogContent>
          <Typography>
            {t('dataEntry.confirmRecordDelete')}
          </Typography>
          <Typography sx={{ mt: 1 }}>
             {t('Search.DeleteBoxContent2')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} disabled={isDeleting} variant="outlined">
            {t('buttons.no')}
          </Button>
          <Button
            onClick={handleBulkDeleteImages}
            color="info"
            variant="contained"
            disabled={isDeleting}
          >
            {t('buttons.yes')}
          </Button>
        </DialogActions>
      </Dialog>
      {retakeImage && <RetakeImageBox rowData={selectedRowData} onClose={handleCloseRetakeImageModal} />}
      {openReprocessImage && <ReprocessImage rowData={selectedRowData} onClose={handleCloseMenuItems} />}
      {openTemplateModal && <UpdateImageTemplate rowData={selectedRowData} onClose={handleCloseTemplateModal} />}
      {openChangeRefImg && <UpdateImgRefImage rowData={selectedRowData} onClose={handleCloseRefImgModal} />}
      {openChangeTempAndRefImg && <UpdateImageTemplateAndRef rowData={selectedRowData} onClose={handleCloseRefImgandTempModal} />}
    </MainRouteSubRoutePage>
  )
}

export default BoxImageDetails
